// Scroll reveals like spykercars.com, on the Who we are page (page.about):
// - images open from a clipped inset(20%) frame to full size while the photo settles from 1.1x scale
// - overlines, headings and text fade in line by line (each line fades, the next follows a beat later)
// Each element reveals once, when it enters the viewport. The hero banner keeps the theme's own iris reveal.
(() => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  const LINE_STAGGER = 0.08; // s between lines
  const sections = [...document.querySelectorAll('main .shopify-section')].filter(
    (section) => !section.querySelector('.media-hero-inner')
  );
  if (!sections.length) return;

  const images = sections.flatMap((section) => [
    ...section.querySelectorAll(
      '.content-block--image, .media-with-text__media, .media-with-text__additionnal-content-image'
    ),
  ])
    // the "Rival around the world" globe stays as it is
    .filter((el) => el.querySelector('img') && !el.closest('[id$="__rich_text_p6why7"]'));

  const texts = sections.flatMap((section) => [
    ...section.querySelectorAll(
      '.content-block--overline, .content-block--heading, .content-block--text, .content-block--button'
    ),
  ]);

  // Wrap every word in a span (keeping links, line breaks and inline styling) so lines can be found
  const splitWords = (root) => {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) if (walker.currentNode.textContent.trim()) nodes.push(walker.currentNode);
    nodes.forEach((node) => {
      const fragment = document.createDocumentFragment();
      node.textContent.split(/(\s+)/).forEach((part) => {
        if (!part) return;
        if (/^\s+$/.test(part)) {
          fragment.append(part);
        } else {
          const word = document.createElement('span');
          word.className = 'sr-word';
          word.textContent = part;
          fragment.append(word);
        }
      });
      node.replaceWith(fragment);
    });
    return [...root.querySelectorAll('.sr-word')];
  };

  const revealText = (block) => {
    if (block.classList.contains('content-block--button')) {
      block.classList.add('sr-in');
      return;
    }
    const words = block._srWords || [];
    // group words into lines by their vertical position, measured now that the layout is final
    let line = -1;
    let lastTop = null;
    const tops = words.map((word) => word.getBoundingClientRect().top);
    words.forEach((word, index) => {
      if (lastTop === null || tops[index] - lastTop > 4) {
        line += 1;
        lastTop = tops[index];
      }
      word.style.transitionDelay = `${(line * LINE_STAGGER).toFixed(2)}s`;
    });
    block.classList.add('sr-in');
  };

  // Clip the frame when it wraps the photo exactly; otherwise (floating photos the theme positions with a
  // transform, partly outside their box) clip the photo itself so nothing gets cropped
  images.forEach((el) => {
    const img = el.querySelector('img');
    const frame = el.getBoundingClientRect();
    const photo = img.getBoundingClientRect();
    const wraps =
      Math.abs(frame.width - photo.width) < 3 &&
      Math.abs(frame.height - photo.height) < 3 &&
      Math.abs(frame.top - photo.top) < 3 &&
      Math.abs(frame.left - photo.left) < 3;
    el.classList.add('sr-image');
    if (!wraps) el.classList.add('sr-image--self');
  });
  texts.forEach((block) => {
    block.classList.add('sr-text');
    if (!block.classList.contains('content-block--button')) block._srWords = splitWords(block);
  });

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const el = entry.target;
        observer.unobserve(el);
        if (el.classList.contains('sr-image')) el.classList.add('sr-in');
        else revealText(el);
      });
    },
    { rootMargin: '0px 0px -12% 0px' }
  );

  [...images, ...texts].forEach((el) => observer.observe(el));
})();
